import { useState } from 'react'
import { ReactComponent as IconClose } from 'bootstrap-icons/icons/x-lg.svg'
import { ReactComponent as IconPencil } from 'bootstrap-icons/icons/pencil.svg'
import { ReactComponent as IconEyeSlash } from 'bootstrap-icons/icons/eye-slash.svg'
import { ReactComponent as IconEye } from 'bootstrap-icons/icons/eye.svg'

import { useMyForms, useApi, paths } from './hooks'
import styles from './styles.module.scss'

const chipsOf = (form) => {
  const chips = []
  chips.push(form.professionals == null ? ['chipGray', 'Todos los profesionales'] : ['chipBrand', 'Solo yo'])
  if (form.specialties == null) chips.push(['chipGray', 'Todas las especialidades'])
  else form.specialties.forEach((s) => chips.push(['chipSpec', String(s).replace('pms_specialties:', '')]))
  return chips
}

function MyForms({ onBack, onEdit, resource, user }) {
  const api = useApi()
  const forms = useMyForms(true)
  const [busy, setBusy] = useState(null)

  // Los formularios solo los administra quien los creó. teamConfig NO otorga
  // admin acá (bug: "Gestionar" dejaba editar/deshabilitar cualquier formulario ajeno).
  const canManage = (form) => !!user?.isStaff || (resource?.id && form.ownerResourceID === resource.id)

  const toggle = async (form) => {
    setBusy(form.id)
    try {
      await api(form.disabled ? paths.enable(form.id) : paths.disable(form.id), { method: 'POST' })
      await forms.refetch()
    } catch (e) {
      console.error('[MyForms] toggle', e.message)
    }
    setBusy(null)
  }

  const rows = forms.data || []

  return (
    <div className={styles.overlay} onClick={onBack}>
      <div className={`${styles.modal} ${styles.modalWide}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.head}>
          <div className={styles.title}>Mis formularios</div>
          <div className={styles.spacer} />
          <button type="button" className={styles.iconbtn} onClick={onBack} aria-label="Cerrar"><IconClose width="16" height="16" /></button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.warn} style={{ marginBottom: '1rem' }}>
            Los formularios <b>no se eliminan</b> (la información cargada es un registro de HCE y debe persistir por
            cuestiones legales). Al <b>ocultar</b>, el formulario deja de aparecer al cargar un registro nuevo,
            pero los datos ya cargados siguen visibles.
          </div>

          {forms.isLoading && <div className={styles.empty}>Cargando…</div>}
          {!forms.isLoading && rows.length === 0 && <div className={styles.empty}>Todavía no creaste formularios.</div>}

          {rows.map((form) => (
            <div key={form.id} className={styles.card} style={{ opacity: form.disabled ? 0.6 : 1 }}>
              <div className={styles.cardHead} style={{ borderBottom: 'none' }}>
                <div>
                  <span className={styles.cardTitle}>{form.name}</span>
                  {form.disabled && <span className={`${styles.chip} ${styles.chipOff}`} style={{ marginLeft: 8 }}>Oculto</span>}
                  {/* Bug real (auditoría 2026-08-21): sin flex-wrap, 2+ especialidades
                      no entraban en el ancho de la card en mobile y se recortaban. */}
                  <div className="d-flex gap-1 mt-1 flex-wrap">
                    {chipsOf(form).map(([cls, text], i) => (<span key={i} className={`${styles.chip} ${styles[cls]}`}>{text}</span>))}
                  </div>
                </div>
                <div className={styles.spacer} />
                {canManage(form) && (
                  form.disabled ? (
                    <button type="button" className={`${styles.btn} ${styles.outline}`} disabled={busy === form.id} onClick={() => toggle(form)}>
                      <IconEye width="13" height="13" /> Mostrar
                    </button>
                  ) : (
                    <>
                      <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={() => onEdit(form)}><IconPencil width="13" height="13" /> Editar</button>
                      <button type="button" className={`${styles.btn} ${styles.danger}`} disabled={busy === form.id} onClick={() => toggle(form)}>
                        <IconEyeSlash width="13" height="13" /> Ocultar
                      </button>
                    </>
                  )
                )}
              </div>
            </div>
          ))}
        </div>      </div>
    </div>
  )
}

export default MyForms
